export const LOGIN_SOURCES = {
    CV_BUILDER: 'Cvbuilder-generate',
    OTHER: 'Other_top-login',
    RESULTLIST: 'Resultlist_top-login',
    SALARY: 'Salary_top-login',
    COVER_LETTER: 'coverletter-generate',
    INTERVIEW_COACH: 'interviewCoach',
    JOB_AD: 'jobAd_checkSalary_header',
    RESULTLIST_FACET_SALARY: 'resultlist_facet-salary',
    RESULTLIST_JOBCARD_SALARY: 'resultlist_jobcard-salary',
    LOGIN: 'LoginPage',
    REGISTRATION: 'RegistrationPage',
    CV_TO_JOB_FIT: 'cvToJobFit',
    SEARCH_ASSISTANT: 'searchAssistant',
    HOMEPAGE_LOGIN_WALL: 'homepage_onLoad',
};
export const FORM_TYPES = {
    LOGIN: 'login',
    REGISTRATION: 'registration',
    REGISTRATION_SUCCESS: 'registrationSuccess',
    RESET_PASSWORD: 'resetPassword',
    GOOGLE_SUCCESS: 'googleSuccess',
    PASSWORDLESS_SUCCESS: 'passwordlessSuccess',
    PASSWORDLESS_INVALID_LINK: 'passwordlessInvalidForm',
    BASIC_TWO_STEP: 'basicTwoStep',
    FULLSCREEN_TWO_STEP: 'fullscreenTwoStep',
    LINKEDIN_IMPORT_PROFILE: 'linkedInImportProfile',
    LINKEDIN_RESPONSE_PAGE: 'linkedInResponsePage',
    // Two-step sub-views
    TWO_STEP_ACCOUNT_IDENTIFIER: 'twoStepAccountIdentifier',
    TWO_STEP_RETURNING: 'twoStepReturning',
    TWO_STEP_LOGIN: 'twoStepLogin',
    TWO_STEP_REGISTRATION: 'twoStepRegistration',
    TWO_STEP_RESET_PASSWORD: 'twoStepResetPassword',
    TWO_STEP_RESET_PASSWORD_SUCCESS: 'twoStepResetPasswordSuccess',
    TWO_STEP_CV_UPLOAD: 'twoStepCvUpload',
    TWO_STEP_APPLE_UPDATE_EMAIL: 'twoStepAppleUpdateEmail',
    TWO_STEP_PASSWORDLESS_CONFIRMATION: 'twoStepPasswordlessConfirmation',
};
//# sourceMappingURL=paramsConfig.js.map